export class AppConstants {
  static APP_NAME = "ShopYourTrip";
  static DOMAIN_NAME = "ShopYourTrip.com";
}
